import SmartDocsTextLogo from '../assets/SmartDocsTextLogoDark.png';
import { BACKEND_BASE_URL } from '../config/runtime';

interface LogoCache {
  [key: string]: {
    url: string;
    timestamp: number;
  };
}

class LogoService {
  private cache: LogoCache = {};
  private readonly CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  // Get the backend base URL for static files
  private getBackendBaseUrl(): string {
    return BACKEND_BASE_URL;
  }

  private getBaseUrl(): string {
    return `${this.getBackendBaseUrl()}/static/company_logos/`;
  }

  /**
   * Get the logo URL for a distributor, with caching
   */
  async getLogoUrl(logoFilename: string | null): Promise<string> {
    if (!logoFilename) {
      return this.getDefaultLogoUrl();
    }

    const cacheKey = logoFilename;
    const now = Date.now();

    // Check if we have a valid cached version
    if (this.cache[cacheKey] && (now - this.cache[cacheKey].timestamp) < this.CACHE_DURATION) {
      return this.cache[cacheKey].url;
    }

    // Construct the logo URL
    const logoUrl = `${this.getBaseUrl()}${logoFilename}`;

    // Cache the URL (we'll let the browser handle image loading)
    this.cache[cacheKey] = {
      url: logoUrl,
      timestamp: now
    };

    return logoUrl;
  }

  /**
   * Get the default SmartDocs logo URL
   */
  getDefaultLogoUrl(): string {
    return SmartDocsTextLogo;
  }

  /**
   * Clear the logo cache
   */
  clearCache(): void {
    this.cache = {};
  }

  /**
   * Preload a logo into cache
   */
  async preloadLogo(logoFilename: string | null): Promise<void> {
    if (logoFilename) {
      await this.getLogoUrl(logoFilename);
    }
  }
}

// Export a singleton instance
export const logoService = new LogoService();
